import React from "react";
import Sidebar from "../shared/Sidebar";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Layout = () => {
  const common = useSelector((state) => state.common);
  const location = useLocation();

  const sidebarSx = {
    height: "100vh",
    overflow: "hidden",
    flexShrink: 0,
    bgcolor: "transparent",
    borderRight: "1px solid rgba(255,255,255,0.1)",
    transition: "width 0.3s ease-in-out",
    zIndex: 1,
  };

  const mainSx = {
    height: "100vh",
    display: "flex",          // ← key: stack header + content vertically
    flexDirection: "column",
    overflow: "hidden",       // ← outer does NOT scroll
    transition: "width 0.3s ease-in-out",
    position: "relative",
    zIndex: 1,
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        backgroundImage: common.dark ? "url(/spacebackground.png)" : "url(/background.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* SIDEBAR */}
      <Box sx={{ ...sidebarSx, width: common.menu ? "5%" : "18%" }}>
        <Sidebar />
      </Box>

      {/* MAIN */}
      <Box sx={{ ...mainSx, width: common.menu ? "95%" : "82%" }}>

        {/* Header stays fixed at top — never scrolls */}
        <Box sx={{ flexShrink: 0 }}>
          <Header />
        </Box>

        {/* Only this area scrolls */}
        <Box component="main" sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
          <Outlet key={location.pathname} />
        </Box>

      </Box>
    </Box>
  );
};

export default Layout;